import React from 'react';
import Insta from '../../assests/images/Instagram.png'

import YoutubeImg from '../../assests/images/youtubeImg.png'
import Flip from '../../assests/images/flipkart.png'
import { ChannelsText, Color1Span, Color2Span, DateDiv, LeftChild, Span1, Span2, StyledContainer, TopicADiv, TwitterText } from './ViewCompetitive.styled';
import { FacebookLogo, FlipkartIcon, FlipkartIconSmall, InstagramLogo, X_LOGO } from '../../Common/SvgIcon/CommonSvgIcons';
import { formatDateFilter } from '../../utils';
const HeaderSubDiv = ({ compData = {}, shared = false,
    topic1 = true }) => {

    const transformText = (inputText) => {
        const words = inputText?.split(' ');
        const transformedWords = words?.map(word => word?.charAt(0).toUpperCase() + word?.slice(1));
        return transformedWords?.join(' ')
    };
    
    const formattedDate = compData?.user_end_date
  ? compData.user_end_date.replace(/\//g, '-')
  : compData?.end_date && compData?.user_end_date == null
    ? new Date().toLocaleDateString("en-GB").replace(/\//g, '-')
    : '';
    return (
        <LeftChild>
            <StyledContainer>
                <ChannelsText>Channel:</ChannelsText>
                <TwitterText>
                    {compData?.channel && (compData?.channel == 'twitter' ? X_LOGO :
                        compData?.channel == 'facebook' ? FacebookLogo :
                            compData?.channel == 'instagram' ? 
                            <> <img src={Insta} style={{width:'20px'}} /></> :
                                compData?.channel == 'flipkart' ? 
                                <> <img src={Flip} style={{width:'25px'}} /></> :
                                compData?.channel == 'youtube' ? 
                                <> <img src={YoutubeImg} style={{width:'25px'}} /></> :
                                    '')}<span style={{ marginLeft: '5px' }}>{compData?.channel && compData?.channel == 'twitter' ? " " : transformText(compData?.channel || '')}</span>
                </TwitterText>
            </StyledContainer>
            <TopicADiv shared={shared}>
                {topic1 ? <Color1Span></Color1Span> : <Color2Span></Color2Span>}
                <Span1 style={{ marginLeft: '8px', lineHeight: '13px', minWidth: '50px' }}>{compData?.channel == 'flipkart' ? 'Chatter' : 'Topic'}  : </Span1>
                <Span2 style={{ lineHeight: '20px', wordBreak: 'break-word' }}>{compData?.chatter_topic_title || ''}</Span2>
            </TopicADiv>
            {
                shared ? <></> :

                    <DateDiv>
                        <div className='label'>Start Date :</div>
                        <div>{compData?.user_start_date?.replace(/\//g, '-')|| ''}</div>

                        <div className='label'>End Date :</div>
                        <div>{formattedDate}</div>
                    </DateDiv>
            }

        </LeftChild>
    );
};
export default HeaderSubDiv;